// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dehQ","top":"styles_top__2WyP5"};